import useRecentArticles from "@/utils/hooks/useRecentArticles";
import RecentStories from "./RecentStories";

const RecentArticlesContainer = () => {
  const {
    articles,
    hasNextPage,
    fetchNextPage,
    isLoading,
    isError,
    isFetchingNextPage,
    refetch,
  } = useRecentArticles({ limit: 6 });

  return (
    <RecentStories
      articles={articles ?? []}
      fetchNextPage={fetchNextPage}
      hasNextPage={!!hasNextPage}
      isError={isError}
      isLoading={isLoading}
      isFetchingNextPage={isFetchingNextPage}
      refetch={refetch}
    />
  );
};

export default RecentArticlesContainer;
